<template>
  <v-container>
    <v-layout
      text-center
      wrap
    >
    CMS 로그 (이벤트 등록, 템플릿 등록)
          <v-data-table
        :headers="headers"
        :items="cms_user_list"
        sort-by="calories"
        class="elevation-1"
      >
      <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title> 유저 리스트 </v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <v-spacer></v-spacer>

          <v-dialog v-model="dialog" max-width="300px">
            <v-card>
              <v-card-title>
                <span class="headline"></span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="9" md="9">
                      <v-text-field v-model="editedItem.purpose" label="변경 유저 레벨 입력"></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" sm="6" md="3">
                        <v-select
                        v-model="editedItem.repeat_type"
                        :items="event_repeat_type"
                        item-text="text"
                        item-value="value"
                        label="반복 타입"
                        persistent-hint
                        ></v-select>
                    </v-col> -->
                  </v-row>
                </v-container>
              </v-card-text>
  
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
            </v-dialog> <!-- end dialog -->

          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon
            small
            @click="deleteItem(item)"
          >
            delete
          </v-icon>
          <v-icon
            small
            @click="updateItem(item)"
          >
            swap_horizontal_circle
          </v-icon>
        </template>

      </v-data-table>
    
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import store from '../../store';
export default {
//   name: 'SideChapterInfo',
  data() {
    return {
        cms_user_list:[],
        headers: [
            { text: '유저아이디', value: 'user_id' },
            { text: '유저 레벨', value: 'level' },
            { text: 'Actions', value: 'action', sortable: false },
        ],
        user_level: [
            {text: '신규가입', value: 0},
            {text: '기본', value: 1},
            {text: '기본2', value: 2},
            {text: 'dev템플릿올리기가능', value: 3},
            {text: '기본3', value: 4},
            {text: '기본4', value: 5},
            {text: 'qa 서버 이벤트 관리가능', value: 6},
            {text: 'live 서버 이벤트 관리가능', value: 7},
            {text: '유저관리 가능', value: 8},
            {text: 'SUPER MASTER(나)', value: 9},
        ],
        dialog: false,
        editedItem: {},
    }
  },
  created() {
      console.log('CREATE EVENT HOME ');
      this.get_user_list();
  },
  computed: {
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
        ...mapActions([
            'GET_CMS_USER_LIST',
            'UPDATE_CMS_USER_LEVEL',
            'DELETE_CMS_USER',
        ]),
        get_user_list() {
            this.GET_CMS_USER_LIST()
            .then((body) => {
                console.log('JS get user list:',body.data);
                if(body.info.code !== 100) {
                    alert(`실패! msg:${body.result.msg}`);
                    this.close();
                    return;
                }
                this.cms_user_list = body.data;
            })
            .catch((err) => {
                this.error = err;
                alert(`에러: ${err}`);
            })
        },
        close () {
            this.dialog = false
        },
        save () {
            this.dialog = false
        },
        updateItem (){
            this.dialog = true;
        },
        deleteItem(item) {
            console.log('JS delete:' ,item)
            this.DELETE_CMS_USER({target_id: item.user_id})
            .then((body) => {
                console.log('JS get user list:',body.data);
                if(body.info.code !== 100) {
                    alert(`실패! msg:${body.result.msg}`);
                    this.close();
                    return;
                }
                this.cms_user_list = body.data;
            })
            .catch((err) => {
                this.error = err;
                alert(`에러: ${err}`);
            })
        }
    },
};
</script>
